// Store order data in session storage
export const storeOrderData = (orderData) => {
    if (!orderData) return;
    
    try {
      sessionStorage.setItem('bucksOrder', JSON.stringify(orderData));
    } catch (error) {
      console.error('Error storing order data in session storage:', error);
    }
  };
  
  // Retrieve order data from session storage
  export const getOrderData = () => {
    try {
      const orderData = sessionStorage.getItem('bucksOrder');
      return orderData ? JSON.parse(orderData) : null;
    } catch (error) {
      console.error('Error retrieving order data from session storage:', error);
      return null;
    }
  };
  
  // Clear order data from session storage
  export const clearOrderData = () => {
    try {
      sessionStorage.removeItem('bucksOrder');
    } catch (error) {
      console.error('Error clearing order data from session storage:', error);
    }
  };